import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import StarRating from 'vue-star-rating';

export default {
  name: 'ReviewModal',
  components: {
    StarRating
  },

  data() {
    return {
      productsData: {}
    };
  },
  created() {
    this._generateFormFields();
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      modalData: 'app/modalData'
    }),
    reviewData() {
      return this.modalData['reviewModal'] || null;
    }
  },
  methods: {
    ...mapMutations({
      modalClose: 'app/MODAL_CLOSE'
    }),
    ...mapActions({
      addProductComment: 'comments/ADD_PRODUCT_COMMENT'
    }),
    getMessageErrors() {
      return [];
    },

    _generateFormFields() {
      if (!this.reviewData?.products?.data) return;

      this.reviewData.products.data.forEach((item) => {
        this.productsData[item.id] = {
          ...item,
          isLoading: false,
          rating: 5,
          message: ''
        };
      });
    },

    onSubmit(id) {
      Vue.set(this.productsData[id], 'isLoading', true);
      try {
        let { message, rating } = this.productsData[id];
        let { email, name } = this.reviewData;
        let payload = { email, message, name, product_id: id, rating };

        this.addProductComment(payload).then(() => {
          this.$toasted.success(this.$t('toast.successFeedbackSend'));
          Vue.delete(this.productsData, id);

          if (!Object.keys(this.productsData).length) {
            this.modalClose('reviewModal');
          }
        });
      } catch (error) {
        this.$toasted.error(this.$t('validation.required'));
      } finally {
        Vue.set(this.productsData[id], 'isLoading', false);
      }
    }
  }
};
